<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout
      row
      wrap
    >
      <v-flex
        xs6
        sm4
        md3
      >
        <v-text-field
          v-model="searchBy.brand"
          prepend-icon="search"
          label="Brand"
          placeholder="Search by Brand"
          clearable
          hide-details
        />
      </v-flex>
      <v-flex
        xs6
        sm4
        md3
      >
        <v-text-field
          v-model="searchBy.category"
          prepend-icon="search"
          label="Category"
          placeholder="Search by Category"
          clearable
        />
      </v-flex>
      <v-flex
        xs6
        sm4
        md3
      >
        <v-text-field
          v-model="searchBy.materialNo"
          prepend-icon="search"
          label="Material No"
          placeholder="Search by Material No."
          clearable
        />
      </v-flex>
      <v-flex
        xs6
        sm4
        md3
      >
        <v-text-field
          v-model="searchBy.materialDesc"
          prepend-icon="search"
          label="Material Desc"
          placeholder="Search by Material Desc"
          clearable
          hide-details
        />
      </v-flex>
      <v-flex
        md12
      >
        <div>
          <!--          <v-spacer/>-->
          <!--          <v-text-field-->
          <!--            v-model="search"-->
          <!--            prepend-icon="search"-->
          <!--            label="Search"-->
          <!--            placeholder="search by brand/material/category/desc"-->
          <!--            clearable-->
          <!--            single-line-->
          <!--            hide-details-->
          <!--          />-->
          <v-data-table
            id="itemaddselection"
            v-model="selected"
            :loading="loading"
            :headers="headers"
            :items="DataList"
            :rows-per-page-items="rowsAmount"
            :pagination.sync="pagination"
            :total-items="totalRows"
            :expand="expand"
            item-key="id"
            dense
            select-all
            loading-text="Loading... Please wait"
            class="elevation-1"
          >

            <template v-slot:items="props">
              <tr
                @click.stop=" (props.expanded = !props.expanded)">
                <td>
                  <v-checkbox
                    v-model="props.selected"
                    hide-details
                    primary
                    @click.stop="props.selected = !props.selected"
                  />
                </td>
                <td>{{ props.item.brand }}</td>
                <td>{{ props.item.category }}</td>
                <td>{{ props.item.materialNo }}</td>
                <!-- <td>{{ props.item.materialDesc }}</td>-->
                <td>{{ props.item.currency }}</td>
                <td class="price-format">{{ toPriceFormat(props.item.price.sellingPrice) }}</td>
                <td class="price-format">{{ toPriceFormat(props.item.price.bottomPrice) }}</td>
              </tr>
            </template>
            <template v-slot:expand="props">
              <v-card>
                <v-card-text align="left"><span class="expand-item">Material Desc:</span> {{ props.item.materialDesc }}
                </v-card-text>
              </v-card>
            </template>
          </v-data-table>
          <v-snackbar
            v-model="snack"
            :timeout="5000"
            :color="snackColor">
            {{ snackText }}
            <v-icon
              size="16"
              @click="snack = false"
            >
              mdi-close-circle
            </v-icon>
          </v-snackbar>
        </div>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
  import displayFormatterMixins from '../../../mixins/displayFormatterMixins'
  import _ from 'lodash'

  export default {
    name: 'ItemSelect',
    // components: { ItemBundling },
    mixins: [displayFormatterMixins],
    data: () => ({
      snack: false,
      valid: false,
      expand: true,
      lazy: false,
      snackColor: '',
      snackText: '',
      checkAll: false,
      selected: [],
      rules: {
        requiredObj: obj => !!(Object.entries(obj).length !== 0) || 'Required.',
        required: value => !!value || 'Required.',
        max50chars: value => !value || value.length <= 50 || 'Max 50 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return !value || pattern.test(value) || 'Invalid e-mail.'
        },
        number: value => !isNaN(value) || 'Must be numeric'
      },
      pagination: {},
      DataList: [],
      totalRows: 0,
      rowsAmount: [20, 5, 50],
      // rowsAmount: [5, 20, 25, { 'text': '$vuetify.dataIterator.rowsPerPageAll', 'value': -1 }],
      loading: true,
      search: '',
      searchBy: {
        brand: '',
        category: '',
        materialNo: '',
        materialDesc: ''
      },
      headers: [
        { text: 'Brand', value: 'brand' },
        { text: 'Category', value: 'category' },
        { text: 'Material', value: 'materialNo', class: 'header-datatable' },
        // { text: 'Desc', value: 'materialDesc' },
        { text: 'Curr', value: 'curr' },
        { text: 'Selling Price', value: 'price.sellingPrice' },
        { text: 'Bottom Price', value: 'price.bottomPrice' }
      ],
      excelFields:
        {
          'Brand': 'brand',
          'Category': 'category',
          'Material': 'materialNo',
          'Desc': 'materialDesc',
          'Currency': 'curr',
          'Selling Price': 'price.sellingPrice',
          'Bottom Price': 'price.bottomPrice'
        },

      companies: []

    }),
    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
      }

    },

    watch: {
      selected () {
        this.$store.commit('quo/setSelectedItems', this.selected)
      },
      pagination: {
        async handler () {
          this.getItems()
        }
      },
      search () {
        console.debug('search watcher')
        this.debouncedGetItems()
      },
      searchBy: {
        handler (oldVal, newVal) {
          console.debug('searchBy Deep')
          this.debouncedGetItems()
        },
        deep: true
      }
    },
    // called after dom render
    mounted () {
    },
    // called before dom render, can access reactive data
    created: function () {
      this.debouncedGetItems = _.debounce(this.getItems, 500)
    },

    methods: {
      setSelectedItemsCheckbox (items) {
        this.selected = items
      },

      toggleAll () {
        if (this.selected.length) this.selected = []
        else this.selected = this.DataList.slice()
      },
      changeSort (column) {
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending
        } else {
          this.pagination.sortBy = column
          this.pagination.descending = false
        }
      },
      async getItems () {
        try {
          this.loading = true
          const { sortBy, descending, page, rowsPerPage } = this.pagination
          let q = this.search == null ? '' : this.search
          let qbra = this.searchBy.brand == null ? '' : this.searchBy.brand
          let qcat = this.searchBy.category == null ? '' : this.searchBy.category
          let qmat = this.searchBy.materialNo == null ? '' : this.searchBy.materialNo
          let qdes = this.searchBy.materialDesc == null ? '' : this.searchBy.materialDesc
          let pageNoXHR = page - 1
          let response = await this.$http.get(`/api/item?ps=${rowsPerPage}&pn=${pageNoXHR}&so=${sortBy || ''}
          &dc=${descending || false}&q=${q}&qbra=${qbra}&qcat=${qcat}&qmat=${qmat}&qdes=${qdes}`)

          this.loading = false
          this.DataList = response.data.content.map(item => {
            let temp = Object.assign({}, item)
            temp.qty = 1
            temp.stockType = 'INDENT'
            return temp
          })
          console.debug('getItems XHR had been modified')
          this.totalRows = response.data.totalElements
        } catch (error) {
          console.log(error)
        }
      },
      async getPriceRule () {
        try {
          let response = await this.$http.get('/api/pricerule?so=name')
          this.priceRuleList = response.data.content
        } catch (error) {
          console.log(error)
        }
      },

      closed () {
        this.selected = []
      },

      // toasts/snackbar messages for actions
      saveInline () {
        this.snack = true
        this.snackColor = 'success'
        this.snackText = 'Data saved/updated'
      },
      cancelInline () {
        this.snack = true
        this.snackColor = 'error'
        this.snackText = 'Canceled'
      },
      deleteInline () {
        this.snack = true
        this.snackColor = 'success'
        this.snackText = 'Data removed'
      },
      reset () {
        this.snack = true
        this.snackColor = 'success'
        this.snackText = 'Data reset to default'
      },
      openInline () {
        this.snack = true
        this.snackColor = 'info'
        this.snackText = 'Dialog opened'
      },
      closeInline () {
        console.debug('Dialog closed')
      },
      checkboxSnack () {
        this.snack = true
        this.snackColor = 'error'
        this.snackText = 'Please select at least one'
      },
      fileFormatSnack () {
        this.snack = true
        this.snackColor = 'error'
        this.snackText = 'Please select xls/xlsx file'
      }
    }
  }
</script>
<style>
  #itemaddselection table.v-datatable thead tr th div.v-input--checkbox  {
    display:none;
  }
</style>
